import { CONSULTATION_TYPE } from '@abiglobalhealth/go-types'
import { SpinningProfiles } from '@components/icons/SpinningProfiles'

import { useConsultationType } from '@/hooks/useConsultationType'
import { getSlugTranslation } from '@/locale/utils'

export const Matching = () => {
  const { consultationType } = useConsultationType()
  return (
    <div className="flex flex-1 flex-col items-center gap-8 p-8" data-testid="matching-container">
      <h2 className="text-center text-2xl font-bold">{getSlugTranslation('matching')}</h2>

      <SpinningProfiles />

      {consultationType === CONSULTATION_TYPE.VIDEO && <span className="text-center">{getSlugTranslation('matching.video.text_message')}</span>}
      <p className="text-center">{getSlugTranslation('match.one_minute')}</p>
    </div>
  )
}
